import React, { Suspense } from 'react'
import { AiOutlineShoppingCart as ShoppingCartIcon } from 'react-icons/ai'
import { observer } from 'mobx-react'
import { Badge, Button } from 'react-bootstrap'
import {
  i18nTranslate,
  isToShowOverrideSubscription,
  application,
  isB2BAccount,
  isB2B2C,
  checkIsMobile,
  isFeatureEnabled,
  enableCartMFE,
  IS_BROWSER,
} from 'src/utils'
import { getSeparateCartAndCheckout, getShowMiniCart } from 'config/appConfig'
import { clearUserCartCache } from 'src/views/components/CartBlock/deps'
import { pageNames } from 'src/routes/pathParams'
import { Cart } from 'src/views/components'
import { MicroFrontendLoader } from 'src/views/components/MicroFrontends/MicroFrontendLoader'
import { CartMFE } from 'src/views/components/CartMFE'
import { cartContainer, checkoutContainer, translationStore, customerContainer } from 'src/models'
import NuskinCartIcon from './NuskinCartIcon'
import './styles.scss'
import { PUBSUB, subscribe, unSubscribeEvent } from 'src/pubsub'

@observer
/*
 * @note
 * changes made as per given PR: EQPLAT - 8517 and 9057
 */
class CartIcon extends React.Component {
  componentDidMount() {
    // Load translations in background
    const enableTranslationFromContentStack = isFeatureEnabled(
      'enableTranslationFromContentStack'
    )
    if (
      enableTranslationFromContentStack &&
      !translationStore.isClientTranslationLoadedAlready
    ) {
      translationStore.fetchTranslationForBrowser(true).catch(err => {
        console.error('Failed to load translations:', err)
      })
    }

    this.cartUpdateToken = subscribe(
      PUBSUB.ADD_TO_CART,
      this.addToCartFromHomeMfe
    )

    this.orderPlacedToken = subscribe(PUBSUB.ORDER_PLACED, this.handleCheckoutMfeOrderPlaced)
  }

  componentWillUnmount() {
    unSubscribeEvent(this.cartUpdateToken)
    unSubscribeEvent(this.orderPlacedToken)
  }

  addToCartFromHomeMfe = async () => {
    await cartContainer.viewCart()
    cartContainer.showAddToCartSuccessMessage()
    cartContainer.toggleCartVisibility()
  }

  handleCheckoutMfeOrderPlaced = async () => {
    try {
      await cartContainer.viewCart()
    } catch (err) {
      console.error('[CartIcon] Failed to refresh cart after ORDER_PLACED:', err)
    }
  }

  handleCartClick = async () => {
    const { pathname } = this.props.location
    const isCheckoutPage =
      pathname === pageNames.checkout ||
      pathname === pageNames.expressCheckout ||
      false
    if (pathname === pageNames.viewCart || isCheckoutPage) {
      if (isCheckoutPage && getSeparateCartAndCheckout()) {
        if (cartContainer?.cartResponse?.loyaltyDetails) {
          await checkoutContainer.deleteDiscountReward()
        }
        this.props.history.push(`${pageNames.viewCart}`)
      } else {
        event.preventDefault()
      }
    } else if (
      application.isTabletOrLarger &&
      !checkIsMobile() &&
      (getShowMiniCart() === true || isB2B2C())
    ) {
      if (cartContainer?.cartResponse?.loyaltyDetails) {
        await checkoutContainer.deleteDiscountReward()
        cartContainer.toggleCartVisibility()
      } else {
        //await cartContainer.viewCart()
        /**
         * @info Commented above and Called below function for delete payment if exists
         * and make user cart call as a common
         */
        clearUserCartCache(true)
        cartContainer.toggleCartVisibility()
      }
    } else {
      if (getSeparateCartAndCheckout() === true) {
        if (cartContainer?.cartResponse?.loyaltyDetails) {
          await checkoutContainer.deleteDiscountReward()
        }
        //await cartContainer.viewCart()
        /**
         * @info Commented above and Called below function for delete payment if exists
         * and make user cart call as a common
         */
        clearUserCartCache(true)
        this.props.history.push(`${pageNames.viewCart}`)
      } else {
        this.props.history.push(`${pageNames.checkout}`)
      }
    }
  }

  render() {
    const { cartCount = 0 } = cartContainer
    const { pathname = '' } = this.props.location
    const { isNuskinHeader = false } = this.props

    const isSubscriptionOverridePage = isToShowOverrideSubscription()

    const isCheckout =
      pathname === pageNames.checkout ||
      pathname === pageNames.expressCheckout ||
      false
    const className = `${
      !isNuskinHeader ? 'cart-count-wrapper' : ''
    } d-flex p-0 bg-transparent nu-cart-button align-items-center ${
      isCheckout ? 'checkout' : ''
    }`
    return (
      <>
        <Button
          variant=""
          className={className}
          aria-label={'cart items added' + `${cartCount}`}
          onClick={this.handleCartClick}
          data-testid="qa-cart">
          <div className="cart-cont pr-2">
            {/* <ShoppingCartIcon
              // className="header-cart-icon"
              style={{
                fontSize: isNuskinHeader ? '24px' : '20px',
                verticalAlign: 'top',
              }}
              aria-label={i18nTranslate('icons.cart', 'cart icon')}
            /> */}
            {isNuskinHeader ? (
              <NuskinCartIcon />
            ) : (
              <ShoppingCartIcon
                // className="header-cart-icon"
                style={{
                  fontSize: '20px',
                  verticalAlign: 'top',
                }}
                aria-label={i18nTranslate('icons.cart', 'cart icon', {
                  nameSpace: 'ssr-resource',
                })}
              />
            )}
            {isNuskinHeader && !isSubscriptionOverridePage && (
              <Badge className="badge-count" pill variant="danger">
                {cartCount > 99 ? '99+' : cartCount}
              </Badge>
            )}
            {!isNuskinHeader && (
              <div className="cart-count pl-1">
                {cartCount > 99 ? '99+' : cartCount}
              </div>
            )}
          </div>
          {!isNuskinHeader && (
            <span className="pl-1 cart-text">
              {i18nTranslate('checkout.cartTitle', 'Cart')}
            </span>
          )}
        </Button>
        {application.isTabletOrLarger &&
          (!isB2BAccount() || isB2B2C()) && (
            // The server renders the legacy <Cart/> while the browser mounts
            // the cart MFE: keep that known server/client difference inside
            // its own Suspense boundary so only this slot client-renders
            // during hydration instead of the whole header.
            <Suspense fallback={null}>
              {enableCartMFE() && IS_BROWSER ? (
                <CartMFE
                  routerHistory={this.props.history}
                  customerData={customerContainer?.profileResponse}
                />
              ) : (
                <Cart {...this.props} />
              )}
            </Suspense>
          )}
      </>
    )
  }
}

export { CartIcon }
